module.exports = __webpack_public_path__ + "static/media/USDC_USDT_Biswap.9bda39e5.png";